import React, { createContext, useContext, useMemo, useReducer } from 'react';
import PropTypes from 'prop-types';
import { storage } from 'utils/usePersistState';

const emptyArr = [];

const initialState = { list: storage.get('favorite', emptyArr) };

function reducer(state, action) {
  let newState;
  switch (action.type) {
    case 'set_favorite':
      newState = (state?.list || emptyArr).concat([action.id]);
      storage.set('favorite', newState);
      return { list: newState };
    case 'remove_favorite':
      newState = (state?.list || emptyArr).filter((x) => x !== action.id);
      storage.set('favorite', newState);
      return { list: newState };
    default:
      throw new Error();
  }
}

const FavoriteContext = createContext();

export const FavoriteWrapper = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <FavoriteContext.Provider value={{ state, dispatch }}>
      {children}
    </FavoriteContext.Provider>
  );
};

FavoriteWrapper.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export const useIsFavorite = (game_id) => {
  const { state, dispatch } = useContext(FavoriteContext);
  const action = useMemo(
    () => ({
      setFavorite: (id) => {
        dispatch({ type: 'set_favorite', id });
      },
      removeFavorite: (id) => {
        dispatch({ type: 'remove_favorite', id });
      },
    }),
    [dispatch]
  );
  const isFavorite = useMemo(
    () => (state?.list || emptyArr).indexOf(game_id) > -1,
    [state, game_id]
  );
  return [isFavorite, action];
};

export const useFavorites = () => {
  const { state } = useContext(FavoriteContext);
  return [state?.list || emptyArr];
};
